import type Rollbar from 'rollbar';

let lastError = '';
let lastErrorTime = 0;

export default function reportErrorDebounced(error: Error, rollbar: Rollbar) {
  const now = Date.now();
  const msg = error.message || String(error);

  if (msg === lastError && now - lastErrorTime < 5000) {
    return;
  }

  lastError = msg;
  lastErrorTime = now;

  try {
    rollbar.error(error);
  } catch (error) {
    console.error('Error creating rollbar:', error);
  }
}
